import {AnnouncementVo} from '../../common/shared/api/nicolas/vo/AnnouncementVo.interface';
import {Announcement} from '../generated/types';

export function createAnnouncement(announcement: AnnouncementVo): Announcement {
  return {
    id: String(announcement.uid),
    title: announcement.title,
    contents: announcement.contents,
    createDt: announcement.create_dt,
  };
}
